// Components
import { useEffect, useState } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { useDeleteConfirmation } from 'hooks/useDeleteConfirmation';
import { useGlobalFieldOrder } from 'hooks/useGlobalFieldOrder';
import { isEmpty } from 'lodash';
import DrawerFields from 'pages/configuration/fields/FieldDrawer';
// Slices
import { fetchFields, fetchFieldsGlobalOrder } from 'slices/field.slice';
import {
  requestExternalOwners,
  requestObjectTypes,
} from 'slices/objectTypes.slice';
import { fetchOrganizationHierarchy } from 'slices/organizationHierarchy.slice';
import {
  fetchReservationTemplates,
  selectedReservationTemplateMap,
} from 'slices/reservationTemplate.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { Button, DefaultContentLayout } from '@timeedit/ui-components';
import { FieldTable } from './FieldTable';
// Types
import GlobalFieldOrderTable from './GlobalFieldOrderTable';

const FieldsPage = () => {
  const dispatch = useAppDispatch();
  const reservationTemplateMap = useAppSelector(selectedReservationTemplateMap); //   data reservation Template Mapped by id;
  const [openDiscardDialog, onCloseDiscardDialog, confirmFn] =
    useDiscardConfirmation();
  const {
    globalFieldOrder,
    changeGlobalOrder,
    saveGlobalOrder,
    hasLocalChanges,
  } = useGlobalFieldOrder();

  const [confirmDelete, contextHolder] = useDeleteConfirmation();

  useEffect(() => {
    dispatch(requestObjectTypes());
    dispatch(requestExternalOwners());
    dispatch(fetchFields());
    dispatch(requestObjectTypes());
    dispatch(fetchOrganizationHierarchy());
    dispatch(fetchFieldsGlobalOrder());
    if (isEmpty(reservationTemplateMap)) {
      dispatch(fetchReservationTemplates());
    }
  }, []);

  const [isModifyingGlobalOrder, setIsModifyingGlobalOrder] = useState(false);
  const actionsButtons: React.ReactNode = isModifyingGlobalOrder ? (
    <div style={{ display: 'flex', gap: '4px' }}>
      <Button
        onClick={() => setIsModifyingGlobalOrder((prev) => !prev)}
        type="default"
      >
        Cancel
      </Button>
      <Button
        onClick={() => saveGlobalOrder()}
        disabled={!hasLocalChanges}
        type="primary"
      >
        Save
      </Button>
    </div>
  ) : (
    <Button
      onClick={() => setIsModifyingGlobalOrder((prev) => !prev)}
      type="default"
    >
      Modify order
    </Button>
  );

  return (
    <DefaultContentLayout
      title="Fields"
      subtitle="Manage fields for your organization"
      actions={actionsButtons}
    >
      <div className="wrapper-table-te">
        {!isModifyingGlobalOrder ? (
          <FieldTable />
        ) : (
          <GlobalFieldOrderTable
            globalFieldOrder={globalFieldOrder}
            changeGlobalOrder={changeGlobalOrder}
          />
        )}
        <DrawerFields />
        <DiscardConfirmation
          open={openDiscardDialog}
          onClose={onCloseDiscardDialog}
          confirmFn={confirmFn}
        />
        {contextHolder}
      </div>
    </DefaultContentLayout>
  );
};

export default FieldsPage;
